import { useSnackbarStore } from "@store/notification";
import { DEFAULT_NOTIFICATIONS_DELAY } from '@helper/constants';

export const handleErrorMessage = (error, delay=DEFAULT_NOTIFICATIONS_DELAY) => {
  const errorMessage = error?.response?.data.error ?? error.message;

  useSnackbarStore.getState().handleError(errorMessage, delay);
  return false;
};

export const handleErrMessage = (message, delay=DEFAULT_NOTIFICATIONS_DELAY) => {
  console.log(delay);
  useSnackbarStore.getState().handleError(message, delay);
  return false;
};

export const handleSuccess = (message, delay=DEFAULT_NOTIFICATIONS_DELAY) => {
  useSnackbarStore.getState().handleSuccess(message, delay);
  return false;
};